import { Brain, HandWaving, Heart, PencilSimple } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { SERVICE_TEMPLATES, type ServiceTemplateKey } from "./onboarding-logic";

interface Props {
  selected: ServiceTemplateKey | null;
  onSelect: (key: ServiceTemplateKey) => void;
}

const CARDS: { key: ServiceTemplateKey; icon: React.ReactNode; title: string }[] = [
  { key: "individual", icon: <Brain className="size-5" weight="duotone" />, title: "Individualna terapija" },
  { key: "intro", icon: <HandWaving className="size-5" weight="duotone" />, title: "Uvodna seansa" },
  { key: "couples", icon: <Heart className="size-5" weight="duotone" />, title: "Terapija za parove" },
];

export function ServiceTemplatePicker({ selected, onSelect }: Props) {
  return (
    <div>
      <div className="mb-2.5 flex items-center justify-between gap-3">
        <span className="text-sm font-semibold">Počni od predloška</span>
        <button
          type="button"
          onClick={() => onSelect("blank")}
          className={cn(
            "inline-flex items-center gap-1.5 rounded-lg border px-3.5 py-2 text-[13px] font-semibold transition-colors",
            selected === "blank"
              ? "border-primary bg-primary/5 text-primary"
              : "border-border bg-card text-muted-foreground shadow-sm hover:border-primary hover:text-primary"
          )}
        >
          <PencilSimple className="size-4" weight="bold" /> Kreni od nule
        </button>
      </div>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(170px,1fr))] gap-3">
        {CARDS.map((c) => {
          const t = SERVICE_TEMPLATES[c.key as keyof typeof SERVICE_TEMPLATES];
          const on = selected === c.key;
          return (
            <button
              key={c.key}
              type="button"
              onClick={() => onSelect(c.key)}
              className={cn(
                "flex flex-col gap-1.5 rounded-xl border p-3.5 text-left transition-all",
                on ? "border-primary bg-primary/5 ring-1 ring-primary" : "border-border bg-card shadow-sm hover:border-primary/50"
              )}
            >
              <span className="flex items-center gap-2 font-semibold">
                <span className="text-primary">{c.icon}</span>
                {c.title}
              </span>
              <span className="text-xs text-muted-foreground">
                {t.durationMinutes} min · {t.price} KM bez PDV-a ·{" "}
                {t.modality === "online" ? "Online" : t.modality === "both" ? "Oboje" : "Uživo"}
              </span>
            </button>
          );
        })}
      </div>
      <p className="mt-2 text-xs text-muted-foreground">
        Klikni predložak da popuniš formu ispod — pa slobodno izmijeni svaki podatak. Ništa nije zaključano.
      </p>
    </div>
  );
}
